"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createNavBlocker = void 0;
var __1 = require("../../..");
var createNavBlocker = function () {
    var blockedEmitted = (0, __1.createEmitter)();
    var emitter = (0, __1.createEmitter)();
    var blockReleaser = function (_) {
        //
    };
    var isBlocked = function () { var _a; return ((_a = emitter.getLast()) === null || _a === void 0 ? void 0 : _a.isBlocked) || false; };
    var modalContent = function () { var _a; return ((_a = emitter.getLast()) === null || _a === void 0 ? void 0 : _a.modalContent) || {}; };
    return {
        block: function (content) {
            if (isBlocked()) {
                throw new Error('Navigation is already blocked.');
            }
            else {
                emitter.publish({ isBlocked: true, modalContent: content });
            }
        },
        unblock: function () {
            if (!isBlocked()) {
                throw new Error('Navigation is already unblocked.');
            }
            else {
                emitter.publish({ isBlocked: false });
            }
        },
        reportBlocked: function () {
            blockedEmitted.publish({});
        },
        releaseBlock: function () {
            blockReleaser(true);
        },
        setBlockReleaser: function (cb) { return blockReleaser = cb; },
        onBlocked: blockedEmitted.addListener,
        addListener: emitter.addListener,
        isBlocked: isBlocked,
        modalContent: modalContent
    };
};
exports.createNavBlocker = createNavBlocker;
//# sourceMappingURL=index.js.map